import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLightRight = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m12.536 4.254-1.43 1.43a.867.867 0 0 0 0 1.227L24.163 20 11.105 33.089a.867.867 0 0 0 0 1.226l1.431 1.431a.867.867 0 0 0 1.227 0l15.132-15.133a.867.867 0 0 0 0-1.226L13.763 4.254a.867.867 0 0 0-1.227 0Z" })
});
export default SvgChevronLightRight;
